import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertTiffToIco() {
  return (
    <ImageConverterTemplate
      sourceFormat="TIFF"
      targetFormat="ICO"
      acceptTypes=".tiff,.tif,image/tiff"
      slug="convert-tiff-to-ico"
      gradientColors="from-purple-500 to-cyan-500"
      accentColor="cyan"
    />
  );
}
